import { type UseToastOptions as ChakraUseToastOptions, useToast as useChakraUseToast } from "@chakra-ui/react";

export type UseToastOptions = ChakraUseToastOptions;

export const useToast = (): ReturnType<typeof useChakraUseToast> => useChakraUseToast();
